import { render, staticRenderFns } from "./ChatShareMenu.vue?vue&type=template&id=491a6ec6"
import script from "./ChatShareMenu.vue?vue&type=script&lang=js"
export * from "./ChatShareMenu.vue?vue&type=script&lang=js"
import style0 from "./ChatShareMenu.vue?vue&type=style&index=0&id=491a6ec6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports